import { addVisible, removeVisible } from './helper';

const CLS = '.validate--tooltip-max';

export function validateMax(element: HTMLInputElement, max: number): boolean {
    if (parseInt(element.value, 10) > max) {
        addVisible(element, CLS);
        return false;
    } else {
        removeVisible(element, CLS);
        return true;
    }
}

export function liveValidateMax(element: HTMLInputElement) {
    const max = parseInt(element.getAttribute('max') as string, 10);
    if (isNaN(max)) {
        return;
    }

    element.addEventListener('input', (e: Event) => {
        return validateMax(element, max);
    });
    element.addEventListener('change', (e: Event) => {
        return validateMax(element, max);
    });
    element.addEventListener('blur', (e: Event) => {
        return validateMax(element, max);
    });
}
